import { CurrencyPipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AsyncSubject, Observable, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { EditorComponent, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { TipoTemplate } from 'src/app/template/shared/template.model';
import { MatDialog } from '@angular/material/dialog';
import { TabelaDinamicaDialogComponent } from '../tabela-dinamica-dialog/tabela-dinamica-dialog.component';
import { GaleriaImagensDialogComponent } from '../../galeria-imagens-dialog/galeria-imagens-dialog.component';
import { NgZone } from '@angular/core';
import { TemplateService } from 'src/app/template/shared/template.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-editor-html-template',
  templateUrl: './editor-html-template.html',
  providers: [
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
  ]
})
export class EditorHtmlTemplateComponent implements OnInit {
  editorConfig: any;
  editorContent: string = '';
  @ViewChild(EditorComponent) editorComponent: EditorComponent;
  editorSubject: Subject<any> = new AsyncSubject();

  @Input() htmlAntigo: any;
  @Input() getTemplateTagsService: (params: any) => Observable<any>;
  @Input() getTemplateTabelasDinamicasService: () => Observable<any>;
  @Input() empresas: any[];
  @Input() tpTemplate: TipoTemplate;
  @Input() objeto: any;
  @Input() postTrocarTagsHtmlService: (params: any) => Observable<any>;
  @Input() BloquearEdicao: boolean = false;

  @Output() novoHtml = new EventEmitter<string>();

  private contentChangeSubject = new Subject<string>();
  private headerButtonApi: any = null;
  private isLoadingTags = false;
  private isLoadingDynamicTables = false;

  tags: any;
  tabelasDinamicas: any;
  editor: any;
  editorLoaded: any = true;

  constructor(
    public dialog: MatDialog,
    private templateService: TemplateService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.injectButtonsLoadingStyle();
    this.setupEditor();
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.htmlAntigo && changes.htmlAntigo.currentValue !== changes.htmlAntigo.previousValue) {
      const contemTagDinamica = /\{\{.*?\}\}/.test(this.htmlAntigo);

      if (contemTagDinamica && typeof this.postTrocarTagsHtmlService === 'function' && this.objeto) {
        this.postTrocarTagsHtmlService(this.objeto).subscribe(response => {
          this.editorContent = response.body || this.htmlAntigo;
        });
      } else {
        this.editorContent = this.htmlAntigo;
      }
    }
  }

  triggerPrint() {
    if (this.editorComponent.editor) {
      this.editorComponent.editor.execCommand('mcePrint');
    }
  }

  private injectButtonsLoadingStyle(): void {
    if (document.getElementById('tox-buttons-loading-style')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'tox-buttons-loading-style';
    style.innerHTML = `
      .tox .tox-tbtn.tox-tbtn--tags-loading,
      .tox .tox-tbtn.tox-tbtn--tags-loading:hover,
      .tox .tox-tbtn.tox-tbtn--tags-loading:focus,
      .tox .tox-tbtn.tox-tbtn--tags-loading:focus-visible,
      .tox .tox-tbtn.tox-tbtn--tags-loading:active,
      .tox .tox-tbtn.tox-tbtn--tags-loading.tox-tbtn--active,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading:hover,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading:focus,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading:focus-visible,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading:active,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading.tox-tbtn--active {
        outline: none !important;
        box-shadow: none !important;
      }

      .tox .tox-tbtn.tox-tbtn--tags-loading .tox-icon,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading .tox-icon {
        position: relative !important;
        width: 16px !important;
        height: 16px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      .tox .tox-tbtn.tox-tbtn--tags-loading .tox-icon svg,
      .tox .tox-tbtn.tox-tbtn--tags-loading .tox-icon i,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading .tox-icon svg,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading .tox-icon i {
        opacity: 0.10 !important;
      }

      .tox .tox-tbtn.tox-tbtn--tags-loading .tox-icon::before,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading .tox-icon::before {
        content: '';
        position: absolute;
        inset: -2px;
        background: rgba(255, 255, 255, 0.92);
        border-radius: 4px;
        z-index: 1;
        pointer-events: none;
      }

      .tox .tox-tbtn.tox-tbtn--tags-loading .tox-icon::after,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading .tox-icon::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 14px;
        height: 14px;
        margin-left: -7px;
        margin-top: -7px;
        box-sizing: border-box;
        border: 2px solid #999;
        border-top-color: transparent;
        border-radius: 50%;
        animation: tox-buttons-spin 0.8s linear infinite;
        z-index: 2;
        pointer-events: none;
      }

      @keyframes tox-buttons-spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      .tox .tox-tbtn.tox-tbtn--tags-loading,
      .tox .tox-tbtn.tox-tbtn--dynamic-tables-loading {
        pointer-events: none !important;
        cursor: default !important;
      }

      /* Impede truncamento do texto no botão de cabeçalho */
      .tox .tox-tbtn.tox-tbtn--header-section {
        width: auto;
      }

      .tox .tox-tbtn.tox-tbtn--header-section .tox-tbtn__select-label {
        width: auto;
        max-width: none;
        overflow: visible;
        text-overflow: unset;
        white-space: nowrap;
      }
    `;

    document.head.appendChild(style);
  }

  private clearTagButtonFocus(): void {
    const buttons = this.getTagButtonElements();

    buttons.forEach((button: HTMLElement) => {
      button.classList.remove('tox-tbtn--active');
    });
  }

  private clearDynamicTablesButtonFocus(): void {
    const buttons = this.getDynamicTablesButtonElements();

    buttons.forEach((button: HTMLElement) => {
      button.classList.remove('tox-tbtn--active');
    });
  }

  private getTagButtonElements(): HTMLElement[] {
    return Array.from(
      document.querySelectorAll('.tox .tox-tbtn[aria-label="Adicionar tag"], .tox .tox-tbtn[aria-label="Add Tag"]')
    ) as HTMLElement[];
  }

  private getDynamicTablesButtonElements(): HTMLElement[] {
    return Array.from(
      document.querySelectorAll('.tox .tox-tbtn[aria-label="Tabelas Dinâmicas"]')
    ) as HTMLElement[];
  }

  private updateTagButtonLoadingState(loading: boolean): void {
    const buttons = this.getTagButtonElements();

    buttons.forEach((button: HTMLElement) => {
      button.classList.toggle('tox-tbtn--tags-loading', loading);
      button.removeAttribute('aria-disabled');
      (button as HTMLButtonElement).disabled = false;
    });
  }

  private updateDynamicTablesButtonLoadingState(loading: boolean): void {
    const buttons = this.getDynamicTablesButtonElements();

    buttons.forEach((button: HTMLElement) => {
      button.classList.toggle('tox-tbtn--dynamic-tables-loading', loading);
      button.removeAttribute('aria-disabled');
      (button as HTMLButtonElement).disabled = false;
    });
  }

  onEditorContentChange(event: any) {
    if (this.htmlAntigo !== event) {
      const contemTagDinamica = this.containsDynamicTags(event);

      if (contemTagDinamica && typeof this.postTrocarTagsHtmlService === 'function' && this.objeto) {
        this.objeto.contratoHtmlTexto = event;

        this.postTrocarTagsHtmlService(this.objeto).subscribe(response => {
          const htmlFinal = response.body || event;
          this.editorContent = htmlFinal;

          this.editorComponent.editor.setContent(htmlFinal);

          this.novoHtml.emit(htmlFinal);
        });
      } else {
        this.editorContent = event;
        this.novoHtml.emit(this.editorContent);
      }
    }
  }

  containsDynamicTags(content: string): boolean {
    const dynamicTagPattern = /\{\{.*?\}\}/;
    return dynamicTagPattern.test(content);
  }

  carregaTags(empresasCurrent) {
    if (empresasCurrent.length > 0) {
      this.getTemplateTagsService(empresasCurrent).pipe(
        map(response => response.body || [])
      ).subscribe(data => {
        return data;
      });
    }
  }

  carregaTabelasDinamicas() {
    if (this.tpTemplate > 0) {
      this.getTemplateTabelasDinamicasService().pipe(
        map(response => response.body || [])
      ).subscribe(data => {
        this.tabelasDinamicas = data;
      });
    }
  }

  onEditorInit(event: any) {
    this.editorSubject.next(event.editor);
    this.editorSubject.complete();
    this.editorLoaded = true;
  }

  private getBlocoAtual(editor: any): HTMLElement | null {
    const startNode = editor.selection.getStart();

    if (!startNode) {
      return null;
    }

    const bloco = editor.dom.getParent(startNode, (node: Node) => {
      if (!node || node.nodeType !== 1) {
        return false;
      }

      const el = node as HTMLElement;
      const tag = el.tagName?.toLowerCase();

      return editor.dom.isBlock(el) || ['td', 'th', 'li'].includes(tag);
    });

    return (bloco as HTMLElement) || null;
  }

  private parsePt(valor: string | null | undefined): number {
    if (!valor) return 0;

    const normalizado = String(valor).trim().toLowerCase();

    if (normalizado.endsWith('pt')) {
      return parseFloat(normalizado.replace('pt', '')) || 0;
    }

    if (normalizado.endsWith('px')) {
      const px = parseFloat(normalizado.replace('px', '')) || 0;
      return px * 0.75;
    }

    if (normalizado.endsWith('cm')) {
      const cm = parseFloat(normalizado.replace('cm', '')) || 0;
      return cm * 28.3465;
    }

    const numero = parseFloat(normalizado);
    return isNaN(numero) ? 0 : numero;
  }

  private aplicarRecuoPrimeiraLinha(editor: any, incrementoPt: number = 35.433) {
    editor.undoManager.transact(() => {
      const span = editor.dom.create('span', {
        'data-tab-indent': 'true',
        'contenteditable': 'false',
        style: `display:inline-block;width:${incrementoPt}pt;min-width:${incrementoPt}pt;vertical-align:baseline;`
      }, '');

      const rng = editor.selection.getRng();
      if (!rng) {
        return;
      }

      rng.deleteContents();
      rng.insertNode(span);

      const novoRange = editor.dom.createRng();
      novoRange.setStartAfter(span);
      novoRange.setEndAfter(span);

      editor.selection.setRng(novoRange);
      editor.nodeChanged();
    });
  }

  private removerRecuoPrimeiraLinha(editor: any, decrementoPt: number = 35.433) {
    const tabNode = this.getTabNodeAnteriorAoCursor(editor);

    if (!tabNode) {
      return;
    }

    editor.undoManager.transact(() => {
      const parent = tabNode.parentNode;
      editor.dom.remove(tabNode);

      if (parent) {
        const novoRange = editor.dom.createRng();
        novoRange.selectNodeContents(parent);
        novoRange.collapse(false);
        editor.selection.setRng(novoRange);
      }

      editor.nodeChanged();
    });
  }

  private getTabNodeAnteriorAoCursor(editor: any): HTMLElement | null {
    const rng = editor.selection.getRng();

    if (!rng || !rng.collapsed) {
      return null;
    }

    let container = rng.startContainer;
    let offset = rng.startOffset;

    if (container.nodeType === Node.TEXT_NODE) {
      const textNode = container as Text;

      if (offset > 0) {
        return null;
      }

      let previousSibling = textNode.previousSibling as HTMLElement | null;
      if (this.isTabIndentNode(previousSibling)) {
        return previousSibling;
      }

      const parent = textNode.parentNode as HTMLElement | null;
      if (parent && parent.childNodes.length > 0) {
        const index = Array.prototype.indexOf.call(parent.childNodes, textNode);
        if (index > 0) {
          const candidate = parent.childNodes[index - 1] as HTMLElement | null;
          if (this.isTabIndentNode(candidate)) {
            return candidate;
          }
        }
      }

      return null;
    }

    if (container.nodeType === Node.ELEMENT_NODE) {
      const element = container as HTMLElement;

      if (offset > 0) {
        const candidate = element.childNodes[offset - 1] as HTMLElement | null;
        if (this.isTabIndentNode(candidate)) {
          return candidate;
        }
      }

      return null;
    }

    return null;
  }

  private isTabIndentNode(node: any): node is HTMLElement {
    return !!node &&
      node.nodeType === Node.ELEMENT_NODE &&
      node.tagName?.toLowerCase() === 'span' &&
      node.getAttribute('data-tab-indent') === 'true';
  }

  private deveRemoverRecuoComBackspace(editor: any): boolean {
    const selection = editor.selection;

    if (!selection || !selection.isCollapsed()) {
      return false;
    }

    return !!this.getTabNodeAnteriorAoCursor(editor);
  }

  private cursorEstaNoInicioDoBloco(editor: any, bloco: HTMLElement): boolean {
    const rng = editor.selection.getRng();

    if (!rng) {
      return false;
    }

    const rangeAntesDoCursor = rng.cloneRange();
    rangeAntesDoCursor.setStart(bloco, 0);

    const fragmento = rangeAntesDoCursor.cloneContents();
    const textoAntesDoCursor = (fragmento.textContent || '')
      .replace(/\u00A0/g, ' ')
      .replace(/\u200B/g, '')
      .trim();

    if (textoAntesDoCursor.length > 0) {
      return false;
    }

    const temElementoAntesDoCursor = Array.from(fragmento.childNodes).some((node: ChildNode) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const texto = (node.textContent || '')
          .replace(/\u00A0/g, ' ')
          .replace(/\u200B/g, '')
          .trim();
        return texto.length > 0;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node as HTMLElement;
        const tag = el.tagName?.toLowerCase();

        if (tag === 'br') {
          return false;
        }

        const texto = (el.textContent || '')
          .replace(/\u00A0/g, ' ')
          .replace(/\u200B/g, '')
          .trim();

        return texto.length > 0;
      }

      return false;
    });

    return !temElementoAntesDoCursor;
  }

  // =====================================================================
  // ESTRUTURA DE TABELA ÚNICA: thead (cabeçalho) + tbody (corpo)
  // =====================================================================

  /**
   * ID único da tabela de layout do template.
   * Usado para localizar a tabela principal no editor.
   */
  private readonly TEMPLATE_TABLE_ID = 'template-layout-table';

  /**
   * Estilos base da tabela de layout.
   */
  private getTemplateTableStyle(): string {
    return 'width: 100%; border-collapse: collapse; table-layout: fixed; border: none;';
  }

  /**
   * Estilos base das células (td) da tabela de layout.
   */
  private getTemplateCellStyle(): string {
    return 'padding: 0; vertical-align: top;';
  }

  /**
   * Retorna o HTML do thead (cabeçalho) para inserção na tabela de layout.
   */
  private getHeaderSectionHtml(): string {
    return `
      <thead data-tipo="cabecalho-template">
        <tr>
           <td style="${this.getTemplateCellStyle()}">
            <div style="padding: 12px; min-height: 30mm;">
              <p><strong>Sess&atilde;o Cabe&ccedil;alho</strong></p>
              <p>Digite aqui o conte&uacute;do do cabe&ccedil;alho...</p>
            </div>
          </td>
        </tr>
      </thead>`;
  }

  /**
   * Retorna o HTML do tbody (corpo) para inserção na tabela de layout.
   * Recebe opcionalmente o conteúdo HTML interno do corpo.
   */
  private getBodySectionHtml(conteudoInterno?: string): string {
    const conteudo = conteudoInterno || '<p>&nbsp;</p>';
    return `
      <tbody data-tipo="corpo-template">
        <tr>
           <td style="${this.getTemplateCellStyle()}">
            <div style="padding: 12px 4px 4px 4px; min-height: 50mm;">
              ${conteudo}
            </div>
          </td>
        </tr>
      </tbody>`;
  }

  /**
   * Localiza a tabela de layout do template no body do editor.
   */
  private getTemplateTable(editor: any): HTMLTableElement | null {
    const body = editor.getBody();
    if (!body) return null;
    return body.querySelector(`table#${this.TEMPLATE_TABLE_ID}`) as HTMLTableElement | null;
  }

  /**
   * Foca o cursor dentro de uma seção (thead ou tbody).
   * Procura o primeiro elemento editável dentro da seção.
   */
  private focarDentroDaSecao(editor: any, secao: HTMLElement | null) {
    if (!secao) return;

    const primeiroBlocoEditavel =
      secao.querySelector('p, div, td, th, li, span') as HTMLElement | null;

    editor.focus();

    if (primeiroBlocoEditavel) {
      editor.selection.select(primeiroBlocoEditavel, true);
      editor.selection.collapse(false);
    } else {
      editor.selection.select(secao, true);
      editor.selection.collapse(false);
    }
  }

  /**
   * Verifica se o cabeçalho (thead) existe dentro da tabela de layout.
   */
  private existeCabecalho(editor: any): boolean {
    const tabela = this.getTemplateTable(editor);
    return !!tabela?.querySelector('thead[data-tipo="cabecalho-template"]');
  }

  /**
   * ATIVAR CABEÇALHO:
   * 1. Pega todo o conteúdo atual do editor (HTML normal, sem tabela)
   * 2. Cria a tabela de layout com thead (cabeçalho vazio para edição) + tbody (conteúdo existente)
   * 3. Foca o cursor no thead para o usuário editar
   */
  private ativarCabecalho(editor: any) {
    const body = editor.getBody();
    if (!body) return;

    editor.undoManager.transact(() => {
      // Captura todo o conteúdo atual do editor (que está "solto", sem tabela)
      const conteudoAtual = body.innerHTML;

      // Monta a tabela completa: thead + tbody com o conteúdo existente
      let tabelaHtml = `<table id="${this.TEMPLATE_TABLE_ID}" style="${this.getTemplateTableStyle()}" data-mce-resize="false">`;
      tabelaHtml += this.getHeaderSectionHtml();
      tabelaHtml += this.getBodySectionHtml(conteudoAtual);
      tabelaHtml += '</table>';

      // Substitui todo o conteúdo do editor pela tabela
      body.innerHTML = tabelaHtml;
    });

    // Foca no thead para o usuário começar a editar o cabeçalho
    const tabela = this.getTemplateTable(editor);
    const thead = tabela?.querySelector('thead[data-tipo="cabecalho-template"]') as HTMLElement | null;
    this.focarDentroDaSecao(editor, thead);

    this.atualizarBotaoCabecalho(editor);
    this.onEditorContentChange(editor.getContent());
  }

  /**
   * DESATIVAR CABEÇALHO:
   * 1. Extrai o conteúdo HTML de dentro do tbody (o div interno)
   * 2. Remove a tabela inteira
   * 3. Coloca o conteúdo extraído do tbody diretamente no editor como HTML normal
   */
  private desativarCabecalho(editor: any) {
    const body = editor.getBody();
    if (!body) return;

    const tabela = this.getTemplateTable(editor);
    if (!tabela) return;

    editor.undoManager.transact(() => {
      // Busca o tbody e extrai o conteúdo interno do div dentro do td
      const tbody = tabela.querySelector('tbody[data-tipo="corpo-template"]');
      let conteudoDoCorpo = '';

      if (tbody) {
        const divConteudo = tbody.querySelector('td > div') as HTMLElement | null;
        if (divConteudo) {
          conteudoDoCorpo = divConteudo.innerHTML;
        } else {
          // Fallback: pega o innerHTML do td diretamente
          const td = tbody.querySelector('td') as HTMLElement | null;
          conteudoDoCorpo = td ? td.innerHTML : '';
        }
      }

      // Se não conseguiu extrair conteúdo, coloca um parágrafo vazio
      if (!conteudoDoCorpo || conteudoDoCorpo.trim() === '') {
        conteudoDoCorpo = '<p>&nbsp;</p>';
      }

      // Substitui todo o conteúdo do editor pelo conteúdo que estava no tbody
      body.innerHTML = conteudoDoCorpo;
    });

    this.atualizarBotaoCabecalho(editor);
    this.onEditorContentChange(editor.getContent());
  }

  /**
   * Atualiza o texto e tooltip do botão de cabeçalho conforme o estado atual.
   */
  private atualizarBotaoCabecalho(editor: any) {
    const temCabecalho = this.existeCabecalho(editor);

    if (this.headerButtonApi) {
      this.headerButtonApi.setText(temCabecalho ? 'Remover Cabeçalho' : 'Sessão Cabeçalho');
      this.headerButtonApi.setTooltip(temCabecalho ? 'Remover cabeçalho e voltar ao editor normal' : 'Adicionar sessão de cabeçalho ao documento');
      // Reaplica estilos inline após troca de texto para garantir que não trunque
      setTimeout(() => this.aplicarEstiloBotaoCabecalho());
    }
  }

  /**
   * Localiza o botão de cabeçalho no DOM do TinyMCE e aplica estilos inline
   * diretamente no elemento para impedir o truncamento do texto.
   */
  private aplicarEstiloBotaoCabecalho(): void {
    const botoes = document.querySelectorAll('.tox .tox-tbtn');
    botoes.forEach((btn: Element) => {
      const label = btn.querySelector('.tox-tbtn__select-label') as HTMLElement | null;
      if (label && (label.textContent?.includes('Cabeçalho') || label.textContent?.includes('cabeçalho'))) {
        // Sobrescreve o width: 7em fixo do skin oxide no container do botão
        (btn as HTMLElement).style.width = 'auto';
        // Garante que o label interno não seja truncado
        label.style.width = 'auto';
        label.style.maxWidth = 'none';
        label.style.overflow = 'visible';
        label.style.textOverflow = 'unset';
        label.style.whiteSpace = 'nowrap';
      }
    });
  }

  setupEditor() {
    this.editorConfig = {
      base_url: '/tinymce',
      suffix: '.min',
      license_key: 'gpl',
      language: 'pt_BR',
      language_url: 'assets/tinymce/pt_BR.js',
      toolbar_mode: 'sliding',
      plugins: 'link image code table emoticons lists preview fullscreen searchreplace insertdatetime advlist quickbars pagebreak',
      toolbar1: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | align lineheight outdent indent | numlist bullist',
      toolbar2: 'insertHeaderSection | link galeriaImagensButton table emoticons| forecolor backcolor removeformat | pagebreak code fullscreen preview  | addTagButton dynamicTablesButton',
      toolbar3: 'customAlertButton',
      menubar: 'file edit view insert format tools table help',
      quickbars_selection_toolbar: 'addTagButton | bold align numlist bullist',
      quickbars_insert_toolbar: 'addTagButton | bold align numlist bullist',
      height: 600,

      // Configurações para a tabela de layout funcionar corretamente no TinyMCE
      valid_elements: '*[*]',
      valid_children: '+table[thead|tbody|tfoot],+thead[tr],+tbody[tr],+tfoot[tr],+tr[td|th],+td[*],+th[*]',
      extended_valid_elements: 'table[*],thead[*],tbody[*],tfoot[*],tr[*],td[*],th[*],div[*],p[*],span[*],img[*],strong[*],em[*],br',
      verify_html: false,

      content_style: `
        body { line-height: 1; }
        p { margin: 0; }

        /* Estilos da tabela de layout no editor */
        table#template-layout-table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
          border: none;
        }

        table#template-layout-table > thead > tr > td,
        table#template-layout-table > tbody > tr > td {
          border: none;
          vertical-align: top;
        }

        /* Fundo e pontilhado do cabeçalho — apenas visual no editor */
        table#template-layout-table thead[data-tipo="cabecalho-template"] > tr > td {
          border-bottom: 1px dashed #999;
          background-color: rgba(235, 245, 255, 0.5);
        }

        /* Garante que tabelas criadas pelo usuário dentro da tabela de layout
           mantenham suas bordas pontilhadas visíveis normalmente */
        table#template-layout-table table {
          border-collapse: collapse;
        }

        table#template-layout-table table td,
        table#template-layout-table table th {
          border: 1px dashed #bbb;
        }

        @media print {
          table#template-layout-table thead[data-tipo="cabecalho-template"] > tr > td {
            border-bottom: none;
            background: transparent;
            background-color: transparent;
          }

          /* Na impressão, tabelas internas usam bordas sólidas normais */
          table#template-layout-table table td,
          table#template-layout-table table th {
            border: 1px solid #000;
          }
        }
      `,
      line_height_formats: '1 1.15 1.5 2',
      pagebreak_separator: '<div style="page-break-before: always; break-before: page;"></div>',
      automatic_uploads: true,
      images_reuse_filename: true,
      images_upload_handler: (blobInfo, progress) => new Promise((resolve, reject) => {
        const file = blobInfo.blob();

        this.templateService.uploadImagemTemplate(file).subscribe({
          next: (response) => {
            if (response.body && response.body.url) {
              const blobUrl = response.body.url;
              const nomeArquivo = blobUrl.split('/').pop();

              const urlImagem = `${environment.webApiSaguiControlUrl}/api/anexo/imagem/${nomeArquivo}`;

              resolve(urlImagem);
              this.snackBar.open('Imagem enviada com sucesso!', 'Fechar', { duration: 3000 });
            } else {
              reject({ message: 'Erro ao fazer upload da imagem: URL não retornada', remove: true });
              this.snackBar.open('Erro ao fazer upload da imagem', 'Fechar', { duration: 5000 });
            }
          },
          error: (error) => {
            const mensagem = error.error?.mensagem || 'Erro ao fazer upload da imagem';
            reject({ message: mensagem, remove: true });
            this.snackBar.open(mensagem, 'Fechar', { duration: 5000 });
          }
        });
      }),

      image_uploadtab: true,
      image_dimensions: true,
      image_description: false,
      image_title: false,
      file_picker_types: 'image',

      setup: (editor) => {
        editor.on('Change', () => {
          this.onEditorContentChange(editor.getContent());
        });

        editor.on('init', () => {
          const body = editor.getBody();

          if (!body) {
            return;
          }

          this.atualizarBotaoCabecalho(editor);

          body.addEventListener('keydown', (e: KeyboardEvent) => {
            const isTab = e.key === 'Tab' || e.keyCode === 9;
            const isBackspace = e.key === 'Backspace' || e.keyCode === 8;

            if (isTab) {
              e.preventDefault();
              e.stopPropagation();
              if ((e as any).stopImmediatePropagation) {
                (e as any).stopImmediatePropagation();
              }

              if (e.shiftKey) {
                this.removerRecuoPrimeiraLinha(editor, 35.433);
              } else {
                this.aplicarRecuoPrimeiraLinha(editor, 35.433);
              }

              this.onEditorContentChange(editor.getContent());
              return false as any;
            }

            if (isBackspace && this.deveRemoverRecuoComBackspace(editor)) {
              e.preventDefault();
              e.stopPropagation();
              if ((e as any).stopImmediatePropagation) {
                (e as any).stopImmediatePropagation();
              }

              this.removerRecuoPrimeiraLinha(editor, 35.433);
              this.onEditorContentChange(editor.getContent());
              return false as any;
            }

            return;
          }, true);
        });

        const flatten = (arr) => [].concat(...arr);

        const generateMenu = (data) => {
          if (!data || Object.keys(data).length === 0) {
            return [{
              type: 'menuitem',
              text: 'Não existem tags disponíveis',
              onAction: () => {}
            }];
          }

          return Object.keys(data).map(key => {
            const item = data[key];

            if (item && (item.hasOwnProperty('placeholder') || item.hasOwnProperty('Placeholder'))) {
              return {
                type: 'menuitem',
                text: item.nome || item.Nome,
                onAction: () => editor.insertContent(item.placeholder || item.Placeholder)
              };
            }

            if (item && typeof item === 'object' && item.nome) {
              const submenuItems = Object.keys(item)
                .filter(subKey => subKey !== 'nome' && item[subKey] !== null)
                .map(subKey => {
                  const subItem = item[subKey];
                  if (subItem && (subItem.hasOwnProperty('placeholder') || subItem.hasOwnProperty('Placeholder'))) {
                    return {
                      type: 'menuitem',
                      text: subItem.nome || subItem.Nome,
                      onAction: () => editor.insertContent(subItem.placeholder || subItem.Placeholder)
                    };
                  }
                  return null;
                }).filter(Boolean);

              return {
                type: 'nestedmenuitem',
                text: item.nome,
                getSubmenuItems: () => submenuItems.length > 0 ? submenuItems : [{
                  type: 'menuitem',
                  text: 'Nenhuma tag neste grupo',
                  onAction: () => {}
                }]
              };
            }

            return null;
          }).filter(Boolean);
        };

        // Botão toggle de Cabeçalho
        editor.ui.registry.addButton('insertHeaderSection', {
          text: 'Sessão Cabeçalho',
          tooltip: 'Adicionar sessão de cabeçalho ao documento',
          onAction: () => {
            if (this.existeCabecalho(editor)) {
              // Já tem cabeçalho → desativar: extrai tbody e coloca no editor normal
              this.desativarCabecalho(editor);
            } else {
              // Não tem cabeçalho → ativar: envolve conteúdo em tabela e cria thead
              this.ativarCabecalho(editor);
            }
          },
          onSetup: (api) => {
            this.headerButtonApi = api;
            setTimeout(() => {
              this.atualizarBotaoCabecalho(editor);
            });

            return () => {
              if (this.headerButtonApi === api) {
                this.headerButtonApi = null;
              }
            };
          }
        });

        editor.ui.registry.addButton('galeriaImagensButton', {
          icon: 'image',
          tooltip: 'Galeria de Imagens',
          onAction: () => this.abrirGaleriaImagens(editor)
        });

        editor.ui.registry.addMenuButton('addTagButton', {
          icon: 'addtag',
          tooltip: 'Adicionar tag',
          fetch: (callback) => {
            if (this.isLoadingTags) {
              return;
            }

            this.isLoadingTags = true;
            this.updateTagButtonLoadingState(true);

            setTimeout(() => {
              this.clearTagButtonFocus();
            }, 0);

            this.getTemplateTagsService(this.empresas).subscribe({
              next: (response) => {
                const tags = response.body || {};
                const items = generateMenu(tags);
                callback(items);
              },
              error: () => {
                this.snackBar.open('Não foi possível carregar as tags. Tente novamente.', 'Fechar', {
                  duration: 4000
                });
              },
              complete: () => {
                this.isLoadingTags = false;
                this.updateTagButtonLoadingState(false);
              }
            });
          }
        });

        if (typeof this.getTemplateTabelasDinamicasService === 'function') {
          editor.ui.registry.addMenuButton('dynamicTablesButton', {
            icon: 'table-classes',
            tooltip: 'Tabelas Dinâmicas',
            fetch: (callback) => {
              if (this.isLoadingDynamicTables) {
                return;
              }

              this.isLoadingDynamicTables = true;
              this.updateDynamicTablesButtonLoadingState(true);

              setTimeout(() => {
                this.clearDynamicTablesButtonFocus();
              }, 0);

              this.getTemplateTabelasDinamicasService().subscribe({
                next: (response) => {
                  const tabelasObject = response.body || {};

                  let items: any[] = [];

                  if (Object.keys(tabelasObject).length === 0) {
                    items = [{
                      type: 'menuitem',
                      text: 'Não existem tabelas dinâmicas disponíveis para esse tipo de template',
                      onAction: () => {}
                    }];
                  } else {
                    items = Object.keys(tabelasObject).map(key => {
                      const tabela = tabelasObject[key];
                      return {
                        type: 'menuitem',
                        text: tabela.informacoesTabela.nome,
                        onAction: () => this.abrirDialogTabelasDinamicas(editor, tabela)
                      };
                    });
                  }

                  callback(items);
                },
                error: () => {
                  this.snackBar.open('Não foi possível carregar as tabelas dinâmicas. Tente novamente.', 'Fechar', {
                    duration: 4000
                  });
                },
                complete: () => {
                  this.isLoadingDynamicTables = false;
                  this.updateDynamicTablesButtonLoadingState(false);
                }
              });
            }
          });
        }
      }
    };
  }

  abrirDialogTabelasDinamicas(editor: any, tabelaSelecionada: any) {
    const dialogRef = this.dialog.open(TabelaDinamicaDialogComponent, {
      width: '600px',
      maxHeight: '90vh',
      data: {
        modo: 'tabela-dinamica',
        tabela: tabelaSelecionada
      }
    });

    dialogRef.afterClosed().subscribe((htmlGerado) => {
      if (htmlGerado) {
        setTimeout(() => {
          editor.insertContent(htmlGerado);
        }, 0);
      }
    });
  }

  abrirGaleriaImagens(editor: any) {
    const dialogRef = this.dialog.open(GaleriaImagensDialogComponent, {
      width: '900px',
      maxWidth: '95vw',
      height: '700px',
      maxHeight: '90vh',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe((resultado) => {
      if (resultado && resultado.url) {
        const imgHtml = `<img src="${resultado.url}" alt="${resultado.nomeArquivo}" style="max-width: 100%;" />`;
        setTimeout(() => {
          editor.insertContent(imgHtml);
        }, 0);
      }
    });
  }

  modifyHtmlBeforePrint(orientacaoPaisagem = false): any {
    let texto = '';
    if (orientacaoPaisagem) {
      texto += '<style>@page { size: A4 landscape; margin: 0; }</style>';
    } else {
      texto += '<style>@page { size: A4 portrait; margin: 0; }</style>';
    }

    texto += '<style>body { margin: 0; }</style>';
    texto += '<style>@media print { @page { margin: 0; } body { margin: 0; } }</style>';

    // Estilos de impressão para a tabela de layout (quando cabeçalho está ativo)
    texto += `<style>
      @media print {
        table#template-layout-table {
          width: 100%;
          border-collapse: collapse;
        }
        table#template-layout-table > thead > tr > td,
        table#template-layout-table > tbody > tr > td {
          border: none;
        }
        table#template-layout-table thead[data-tipo="cabecalho-template"] > tr > td {
          border-bottom: none;
          background: transparent;
        }
        table#template-layout-table table td,
        table#template-layout-table table th {
          border: 1px solid #000;
        }
      }
    </style>`;

    texto += '</head><body onload="window.print()" style="padding: 12px;">' + this.novoHtml + '</body></html>';
    return texto;
  }
}
